import { initializeApplicationEnv } from './app/config/env'

initializeApplicationEnv()
	.then(() => import('./bootstrap'))
	.catch(error => {
		console.error('Application startup failed', error)
		const container = document.getElementById('root')
		if (container) {
			container.setAttribute('role', 'alert')
			container.textContent = 'Не удалось загрузить настройки приложения. Обратитесь к администратору.'
		}
	})
